// 메시지(SMS/카카오 알림톡) 설정 섹션 URL (2026-08-09 KST 추가)
import urlJoin from "url-join";

export type MessageSettingsTab =
  | "sms-settings"
  | "sms-send"
  | "sms-templates"
  | "sms-history"
  | "alimtalk-settings"
  | "alimtalk-templates"
  // 2026-08-12 KST 추가
  | "alimtalk-automation";

export const DEFAULT_MESSAGE_SETTINGS_TAB: MessageSettingsTab = "sms-settings";

const messageSettingsSection = "/message-settings/";

export const messageSettingsPath = messageSettingsSection;

export const messageSettingsTabPath = (tab: MessageSettingsTab) =>
  urlJoin(messageSettingsSection, tab);

export const messageSettingsUrl = messageSettingsTabPath(DEFAULT_MESSAGE_SETTINGS_TAB);
